export const GLOBALSERVERREQUESTPENDINGSTATEMESSAGE = "Please wait! while processing your request";
export const SIGNINREQUESTLOADERMESSAGE = "Please wait! Verifying your credentials";
